import {airBlue, airBlueLight, landGreen, landGreenLight, warning} from '@modifi/colors'

const modifiColorMap = [
  [airBlue, airBlueLight],
  [landGreen, landGreenLight],
  [warning, '#FDF5DD'],
]

// using color by name instead of random so that color remains same and doesn't flash b/w renders
export const getModifiColorByName = (
  firstName: string,
  lastName: string
): {textColor: string; bgColor: string} => {
  const index = Math.floor(
    (firstName.charCodeAt(0) + lastName.charCodeAt(0)) % modifiColorMap.length
  )

  return {textColor: modifiColorMap[index][0], bgColor: modifiColorMap[index][1]}
}
